module.exports = __webpack_public_path__ + "static/homeHero-466353c71c02d7ffb332ac639d59315e.jpg";